import { render, staticRenderFns } from "./UserFileSidebar.vue?vue&type=template&id=6c546754&scoped=true&"
import script from "./UserFileSidebar.vue?vue&type=script&lang=js&"
export * from "./UserFileSidebar.vue?vue&type=script&lang=js&"
import style0 from "./UserFileSidebar.vue?vue&type=style&index=0&id=6c546754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c546754",
  null
  
)

export default component.exports